import userService from '../../services/user';
import router from '../../router';

const userData = JSON.parse(localStorage.getItem('user'));

const state = userData
    ? { status: { loggedIn: true }, user: userData }
    : { status: {}, user: null };

const getters = {
    loggedIn: (state) => state.status && state.status.loggedIn || false,
    token: (state) => state.user && state.user.token,
}

const actions = {
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });
    
        return userService.login(email, password)
            .then((user) => {
                commit('loginSuccess', user);
                router.push('/');
            })
            .catch((error) => {
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            })
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
};

export const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};